import { axiosServiceInstance } from '../axios';

export type TPresignedUploadResponse = { uploadUrl: string; publicUrl: string | null };

export const getPresignedUploadUrl = async (
  key: string,
  contentType: string,
  folder?: string,
): Promise<TPresignedUploadResponse> => {
  const res = await axiosServiceInstance.get<TPresignedUploadResponse>('/upload/presigned-url', {
    params: { key, contentType, ...(folder && { folder }) },
  });
  return res.data;
};
